import { render, staticRenderFns } from "./WhoIsHome.vue?vue&type=template&id=c8e9cf36&"
import script from "./WhoIsHome.vue?vue&type=script&lang=js&"
export * from "./WhoIsHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports